import { render, staticRenderFns } from "./MenuTabsScrollable.vue?vue&type=template&id=621cc9fc"
import script from "./MenuTabsScrollable.vue?vue&type=script&lang=js"
export * from "./MenuTabsScrollable.vue?vue&type=script&lang=js"
import style0 from "./MenuTabsScrollable.vue?vue&type=style&index=0&id=621cc9fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports